<script>
  import aprovarPesquisaPassagem from '../servico';
  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import projetoServico from '~modulos/projeto/servico';

  import PesquisaPassagem from './compartilhado/AprovarPassagemLista.vue';
  import SemLista from './compartilhado/AprovarPassagemSemLista.vue';

  export default {
    components: {
      PesquisaPassagem,
      SemLista,
    },
    data() {
      return {
        pesquisasPassagem: [],
        carregando: true,
        animated: true,
        configuracao: this.$storage.configuracao(),
        filtros: this.camposFiltros(),
        projetos: [],

        mostrarPesquisasPassagem: false,
        mostrarSemPesquisa: false,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("AprovarPesquisaPreco")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      camposFiltros() {
        return {
          IdProjeto: 0,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      limparPesquisasPreco() {
        this.mostrarPesquisasPassagem = false;
        this.mostrarSemPesquisa = false;
      },
      lista() {
        this.carregando = true;
        this.limparPesquisasPreco();

        return aprovarPesquisaPassagem.lista(this.filtros)
          .then(res => {
            this.carregando = false;

            this.pesquisasPassagem = res.registros;
            this.setarVisibilidade();
          });
      },
      setarVisibilidade() {
        this.mostrarPesquisasPassagem = (this.pesquisasPassagem.length > 0);
        this.mostrarSemPesquisa = !(this.mostrarPesquisasPassagem);
      },
    },
    created() {
      this.lista();
    },
    mounted() {
      this.$root.tituloDaPagina = `Aprovar Pesquisa de Passagem - Lista`;
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'IdProjeto', this.value);
        });
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
     <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins" id="filter">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.IdProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-search"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div v-if="carregando">
              <div class="btn-group btn-group-justified  hidden-print" role="group">
                <div class="btn-group" role="group">
                  <button type="button" :class="['btn btn-outline-primary', {'active': true}]" style="background-color: #d3d3d347">
                    <i class="fa fa-spinner fa-pulse"></i>  Carregando...
                  </button>
                </div>
              </div>
            </div>

            <div v-if="mostrarPesquisasPassagem">
              <pesquisa-passagem ref="pesquisaPassagem"
                              :pesquisasPassagem.sync="pesquisasPassagem"
                              :filtros.sync="filtros"
                              @lista="lista"
                              v-if="mostrarPesquisasPassagem">
              </pesquisa-passagem>

              <div class="hr-line-dashed margin-top-5"></div>

            </div>

            <div v-if="mostrarSemPesquisa">
              <sem-Lista ref="SemLista"
                         :pesquisasPassagem.sync="pesquisasPassagem"
                         @lista="lista"
                         v-if="mostrarSemPesquisa">
              </sem-Lista>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/aprovar-passagem/componentes/AprovarPassagemLista.vue